import { MissingPage } from 'hatch-components';
import React from 'react';
import { useConnect } from 'redux-bundler-hook';
import DefaultTemplate from 'root/components/templates/Default';
import { GENERAL } from 'root/stores/routes/APP_URLS';
import urlFormatter from 'utils/urlFormatter';

import {
  StyledButton,
  StyledHeader,
  StyledNotFound,
  StyledNotFoundMessage,
  StyledSubHeader,
} from './styles';

const NotFound = () => {
  const { doUpdateUrl, defaultOrganizationId } = useConnect(
    'doUpdateUrl',
    'selectDefaultOrganizationId',
  );
  const url = defaultOrganizationId
    ? urlFormatter({ organizationId: defaultOrganizationId, url: GENERAL })
    : false;

  return (
    <DefaultTemplate title="Not Found">
      <StyledNotFound>
        <StyledNotFoundMessage>
          <MissingPage />
          <StyledHeader>We looked everywhere.</StyledHeader>
          <StyledSubHeader>
            Looks like this page doesn&apos;t exist
          </StyledSubHeader>
          {url && (
            <StyledButton
              data-test-id="45749c88-8f87-421c-aad3-aeef420eb117"
              onClick={() => doUpdateUrl(url)}
              textColor="primary"
              variant="ghost"
            >
              Go Back
            </StyledButton>
          )}
        </StyledNotFoundMessage>
      </StyledNotFound>
    </DefaultTemplate>
  );
};

export default NotFound;
